module.exports = __webpack_public_path__ + "img/27.3.TP.1480eafe.png";